import {
  LIST_TRANSACTIONS,
  DELETE_TRANSACTIONS,
  FETCH_TRANSACTION,
  GET_TRANSACTION_BY_ORDER_ID,
} from "../util/constants";
import { sendRequest } from "./base";

export const getAllTransactions = async (
  data,
  page,
  token,
  limit,
  status = "APPROVED"
) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      data,
      "POST",
      `${LIST_TRANSACTIONS}?page=${page + 1}&pageSize=${limit}&status=${status}`,
      { Authorization }
    );
  } catch (err) {
    return err;
  }
};
export const getTransactionByOrderId = async (orderId) => {
  try {
    return sendRequest(
      null,
      "GET",
      `${GET_TRANSACTION_BY_ORDER_ID}?bankOrderId=${orderId}`
    );
  } catch (err) {
    return err;
  }
};

export const deleteTransactions = async (selectedIds, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest({ data: selectedIds }, "DELETE", `${DELETE_TRANSACTIONS}`, {
      Authorization,
    });
  } catch (err) {
    return err;
  }
};

export const searchTransactions = async (
  data,
  SearchValue,
  token,
  status = "APPROVED"
) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      data,
      "POST",
      `${LIST_TRANSACTIONS}?searchBy=${SearchValue}&status=${status}`,
      { Authorization }
    );
  } catch (e) {
    return e;
  }
};

export const getTransactionById = async (id, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(null, "GET", `${FETCH_TRANSACTION}/byId?transactionId=${id}`, { Authorization });
  } catch (err) {
    return err;
  }
};
